export default "__VITE_ASSET__B$v3Jq2d__"